import {storeLocalStorageVariable} from "@/helper/localstorage";
import app from "dashboard/app";
import * as queries from "dashboard/store/queries";
import gql from "graphql-tag";

export async function setSavePreferredLipidsUnit({commit}, { preferredLipidsUnit, storeBackEnd }) {
  commit('setPreferredLipidsUnit', preferredLipidsUnit);
  storeLocalStorageVariable('preferredLipidsUnit', preferredLipidsUnit);

  return storeBackEnd ? await app.apolloClient.mutate({
    mutation: queries.updateMyUserPreferredLipids,
    variables: {
      preferredLipidsUnit: preferredLipidsUnit
    },
  }) : await Promise.resolve();
}

export async function setSavePreferredGlucoseUnit({commit}, { preferredGlucoseUnit, storeBackEnd }) {
  commit('setPreferredGlucoseUnit', preferredGlucoseUnit);
  storeLocalStorageVariable('preferredGlucoseUnit', preferredGlucoseUnit);

  return storeBackEnd ? await app.apolloClient.mutate({
    mutation: queries.updateMyUserPreferredGlucose,
    variables: {
      preferredGlucoseUnit: preferredGlucoseUnit
    },
  }) : await Promise.resolve();
}

export async function fetchAndStoreUserData({dispatch}) {
  await app.apolloMobileClient
    .query({
      query: gql`{
            myUser {
              preferredLipidsUnit
              preferredGlucoseUnit
            }
          }`,
    }).then((result) => {
      const userData = result.data.myUser;
      dispatch('setSavePreferredLipidsUnit', { preferredLipidsUnit : userData.preferredLipidsUnit });
      dispatch('setSavePreferredGlucoseUnit', { preferredGlucoseUnit : userData.preferredGlucoseUnit });
    });
}
